import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

export const CTASection = () => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <section ref={ref} className="py-24 lg:py-32 relative">
      {/* Background glow */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full bg-primary/[0.06] blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="glass-card rounded-3xl p-10 lg:p-16 text-center glow-border-primary"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={isVisible ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="w-14 h-14 rounded-2xl bg-primary/15 flex items-center justify-center mx-auto mb-6"
          >
            <Sparkles size={24} className="text-primary" />
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight"
          >
            Ready to Launch Your{' '}
            <span className="gradient-text-primary">AI Agent</span>?
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="text-base lg:text-lg text-muted-foreground font-body leading-relaxed max-w-xl mx-auto mb-10"
          >
            Start your 7-day free trial today. No credit card required. 
            Set up your WhatsApp AI agent in under 5 minutes.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Button variant="premium" size="xl" asChild>
              <a href="https://app.agentick.in" target="_blank" rel="noopener noreferrer">
                Start 7-Day Free Trial
                <ArrowRight size={18} />
              </a>
            </Button>
            <Button variant="glass" size="xl" asChild>
              <a href="https://app.agentick.in" target="_blank" rel="noopener noreferrer">Book a Demo</a>
            </Button>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 0.5, delay: 0.7 }}
            className="text-xs text-muted-foreground font-body mt-6"
          >
            Free 7-day trial • No credit card • Cancel anytime
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};
